import styled from 'styled-components';

export const ProgressTrack = styled.div<{ $height: number }>`
  position: relative;
  width: 100%;
  height: ${({ $height }) => $height}px;
  border-radius: ${({ $height }) => $height}px;
  background: ${({ theme }) => theme.gray};
  overflow: hidden;
`;

/* Width through a transform rather than the width itself, so a change of
   value animates on the compositor. */
export const ProgressFill = styled.div<{ $color: string }>`
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: ${({ $color }) => $color};
  transform-origin: left center;
  transition: transform 0.3s ease;
`;
